var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnhanceRotationsTestIconTail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 100,
    viewBox: "0 0 203 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.022,
    cy: 50,
    rx: 50.0219,
    ry: 50,
    fill: "#142533"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.8626 59.7701L97.5842 57.7895L102.538 57.0937L102.816 59.0742L97.8626 59.7701Z",
    fill: "#142533"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4585 60.8102L90.18 58.8297L95.1335 58.1338L95.412 60.1143L90.4585 60.8102Z",
    fill: "#142533"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5236 61.7844L83.2451 59.8039L88.1986 59.108L88.4771 61.0885L83.5236 61.7844Z",
    fill: "#142533"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5887 62.7586L76.3102 60.7781L81.2637 60.0822L81.5422 62.0627L76.5887 62.7586Z",
    fill: "#142533"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6277 63.7365L69.3492 61.756L74.3027 61.0601L74.5812 63.0406L69.6277 63.7365Z",
    fill: "#142533"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6928 64.7107L62.4143 62.7302L67.3678 62.0343L67.6463 64.0148L62.6928 64.7107Z",
    fill: "#142533"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7578 65.6849L55.4794 63.7044L60.4329 63.0085L60.7114 64.989L55.7578 65.6849Z",
    fill: "#142533"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8229 66.6591L48.5445 64.6786L53.498 63.9827L53.7764 65.9633L48.8229 66.6591Z",
    fill: "#142533"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.888 67.6333L41.6096 65.6528L46.5631 64.9569L46.8415 66.9375L41.888 67.6333Z",
    fill: "#142533"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9531 68.6075L34.6746 66.627L39.6282 65.9311L39.9066 67.9117L34.9531 68.6075Z",
    fill: "#142533"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0182 69.5818L27.7397 67.6012L32.6932 66.9054L32.9717 68.8859L28.0182 69.5818Z",
    fill: "#142533"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0182 69.5818L27.7397 67.6012L32.6932 66.9054L32.9717 68.8859L28.0182 69.5818Z",
    fill: "#142533"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0182 69.5818L27.7397 67.6012L32.6932 66.9054L32.9717 68.8859L28.0182 69.5818Z",
    fill: "#142533"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0182 69.5818L27.7397 67.6012L32.6932 66.9054L32.9717 68.8859L28.0182 69.5818Z",
    fill: "#142533"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0833 70.556L20.8048 68.5754L25.7583 67.8796L26.0368 69.8601L21.0833 70.556Z",
    fill: "#142533"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0833 70.556L20.8048 68.5754L25.7583 67.8796L26.0368 69.8601L21.0833 70.556Z",
    fill: "#142533"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0833 70.556L20.8048 68.5754L25.7583 67.8796L26.0368 69.8601L21.0833 70.556Z",
    fill: "#142533"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0833 70.556L20.8048 68.5754L25.7583 67.8796L26.0368 69.8601L21.0833 70.556Z",
    fill: "#142533"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1484 71.5302L13.8699 69.5496L18.8234 68.8538L19.1019 70.8343L14.1484 71.5302Z",
    fill: "#142533"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1484 71.5302L13.8699 69.5496L18.8234 68.8538L19.1019 70.8343L14.1484 71.5302Z",
    fill: "#142533"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1484 71.5302L13.8699 69.5496L18.8234 68.8538L19.1019 70.8343L14.1484 71.5302Z",
    fill: "#142533"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1484 71.5302L13.8699 69.5496L18.8234 68.8538L19.1019 70.8343L14.1484 71.5302Z",
    fill: "#142533"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21347 72.5044L6.93501 70.5239L11.8885 69.828L12.167 71.8085L7.21347 72.5044Z",
    fill: "#142533"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21347 72.5044L6.93501 70.5239L11.8885 69.828L12.167 71.8085L7.21347 72.5044Z",
    fill: "#142533"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21347 72.5044L6.93501 70.5239L11.8885 69.828L12.167 71.8085L7.21347 72.5044Z",
    fill: "#142533"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21347 72.5044L6.93501 70.5239L11.8885 69.828L12.167 71.8085L7.21347 72.5044Z",
    fill: "#142533"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0.278564 73.4786L9.64378e-05 71.4981L4.9536 70.8022L5.23207 72.7827L0.278564 73.4786Z",
    fill: "#142533"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0.278564 73.4786L9.64378e-05 71.4981L4.9536 70.8022L5.23207 72.7827L0.278564 73.4786Z",
    fill: "#142533"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0.278564 73.4786L9.64378e-05 71.4981L4.9536 70.8022L5.23207 72.7827L0.278564 73.4786Z",
    fill: "#142533"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0.278564 73.4786L9.64378e-05 71.4981L4.9536 70.8022L5.23207 72.7827L0.278564 73.4786Z",
    fill: "#142533"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0.278564 73.4786L9.64378e-05 71.4981L4.9536 70.8022L5.23207 72.7827L0.278564 73.4786Z",
    fill: "#142533"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0.278564 73.4786L9.64378e-05 71.4981L4.9536 70.8022L5.23207 72.7827L0.278564 73.4786Z",
    fill: "#142533"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0.278564 73.4786L9.64378e-05 71.4981L4.9536 70.8022L5.23207 72.7827L0.278564 73.4786Z",
    fill: "#142533"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0.278564 73.4786L9.64378e-05 71.4981L4.9536 70.8022L5.23207 72.7827L0.278564 73.4786Z",
    fill: "#142533"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_870_298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.035 18.2031C156.375 18.5713 147.501 26.252 147.285 26.6709C146.993 27.1787 146.993 27.8643 147.285 28.3721C147.526 28.8164 156.565 36.624 157.124 36.8779C157.962 37.2588 159.066 36.8652 159.498 36.0273C159.701 35.6338 159.752 35.2783 159.752 34.377V33.2344H162.989H166.227V42.1211C166.227 50.792 166.239 51.0332 166.48 51.5156C166.646 51.8457 166.912 52.1123 167.242 52.2773C167.712 52.5186 167.979 52.5312 171.939 52.5312C175.9 52.5312 176.167 52.5186 176.637 52.2773C176.967 52.1123 177.233 51.8457 177.398 51.5156C177.652 51.0205 177.652 50.792 177.652 37.1699C177.652 23.5478 177.652 23.3193 177.398 22.8242C177.233 22.4941 176.967 22.2275 176.637 22.0625C176.154 21.8213 175.913 21.8086 167.94 21.8086H159.752V20.666C159.752 19.7646 159.701 19.4092 159.498 19.0156C159.054 18.1396 157.873 17.7588 157.035 18.2031ZM156.197 24.6016C156.362 24.9316 156.629 25.1982 156.959 25.3633C157.441 25.6045 157.683 25.6172 165.655 25.6172H173.844V37.1699V48.7227H171.939H170.035V39.8359C170.035 31.165 170.022 30.9238 169.781 30.4414C169.616 30.1113 169.35 29.8447 169.02 29.6797C168.537 29.4385 168.283 29.4258 162.989 29.4258C157.695 29.4258 157.441 29.4385 156.959 29.6797C156.629 29.8447 156.362 30.1113 156.185 30.4541L155.931 30.9746L155.651 30.7334C155.499 30.5937 154.61 29.8447 153.696 29.0576C152.77 28.2578 152.008 27.5723 152.008 27.5215C152.008 27.4326 155.816 24.1064 155.905 24.0937C155.931 24.0937 156.058 24.3223 156.197 24.6016Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.338 48.7353C126.046 48.8877 125.754 49.1797 125.602 49.4844C125.348 49.9795 125.348 50.208 125.348 63.8301C125.348 77.4521 125.348 77.6807 125.602 78.1758C125.767 78.5059 126.033 78.7725 126.363 78.9375C126.846 79.1787 127.087 79.1914 135.06 79.1914H143.248V80.334C143.248 81.2353 143.299 81.5908 143.502 81.9844C143.934 82.8223 145.025 83.2158 145.876 82.835C146.485 82.5684 155.347 74.9131 155.651 74.3926C156.02 73.7959 156.02 73.1611 155.651 72.5644C155.347 72.0439 146.473 64.3887 145.876 64.1094C145.355 63.8809 144.771 63.9316 144.213 64.249C143.464 64.6807 143.248 65.1885 143.248 66.585V67.7656H140.011H136.773V58.8789C136.773 50.208 136.761 49.9668 136.52 49.4844C136.354 49.1543 136.088 48.8877 135.758 48.7227C135.288 48.4814 135.021 48.4687 131.035 48.4687C127.074 48.4814 126.782 48.4941 126.338 48.7353ZM132.965 61.1641C132.965 69.835 132.978 70.0762 133.219 70.5586C133.384 70.8887 133.65 71.1553 133.98 71.3203C134.463 71.5615 134.717 71.5742 140.011 71.5742C145.305 71.5742 145.559 71.5615 146.041 71.3203C146.371 71.1553 146.638 70.8887 146.815 70.5459C147.044 70.0762 147.095 70.0508 147.285 70.2031C149.723 72.2725 150.992 73.3896 150.992 73.4785C150.992 73.5547 149.621 74.7734 147.298 76.7412C147.107 76.9062 147.044 76.8555 146.79 76.3857C146.193 75.332 146.676 75.3828 137.383 75.3828H129.156V63.8301V52.2773H131.061H132.965V61.1641Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.769 68.1621V63.0755L170.231 57.064C169.338 57.0936 169.075 57.3305 168.846 57.9889V71.8615C149 73.7112 168.385 87.1213 175.308 77.4105V66.3124L180.385 68.6245C180.963 68.8319 181.274 68.7945 181.769 68.1621ZM179.923 64.0003L171.154 59.8386V71.8615C171.102 73.6106 170.995 74.3797 170.231 74.1736C154.077 75.0984 167.462 81.5723 173.462 76.6933V64.4628C173.292 63.8321 173.627 63.6973 174.385 63.5379L179.923 66.3124V64.0003Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.631 36.1548L120.488 37.3452V40.9167L127.631 39.7262V36.1548ZM127.631 36.1548V25.1429M141.917 23.0595V19.4881L127.631 21.2738V25.1429M141.917 23.0595L127.631 25.1429M141.917 23.0595V34.369M141.917 34.369L134.774 35.5595V39.131L141.917 37.9405V34.369Z",
    stroke: "#F2F2F2",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_870_298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    transform: "translate(119 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhanceRotationsTestIconTail);
export default __webpack_public_path__ + "static/media/EnhanceRotationsTestIconTail.7ea77987d6b4683ca1666c1597907d16.svg";
export { ForwardRef as ReactComponent };